import React, { useState } from 'react';
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
// import "swiper/css/pagination";
import "../../../src/swiper-overrides.css";
import { Link } from "react-router-dom";

const images = [
  "/images/donbosco1.jpg",
  "/images/2.jpg",
  "/images/gymnazia.jpg",
  "/images/who-we.jpg",
  "/images/centrebosco.jpg",
];

const phrases = [
  "''Виховання - це справа серця''",
  "''Любов — основа навчання''",
  "''Кожна дитина — унікальна''",
  "''Розум росте в атмосфері добра''",
  "''Навчай із серцем, не лише з розумом''",
];

const DropdownMenu = ({ isOpen, onMouseEnter, onMouseLeave, links }) => (
  <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave} className="relative">
    <div className="z-40 cursor-pointer md:uppercase text-md hover:font-semibold hover:underline">
      <h4>{links.title}</h4>
    </div>
    {isOpen && (
      <div className="absolute z-50 bg-white border border-black rounded shadow-lg">
        <ul className="p-4 w-max">
          {links.items.map((item, index) => (
            <li key={index}>
              <Link to={item.link}>
                <h4 className="text-base text-black md:uppercase hover:text-black hover:underline">
                  {item.label}
                </h4>
              </Link>
            </li>
          ))}
        </ul>
      </div>
    )}
  </div>
);

const Header = ({ className = '', isHomePage = false }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };
  const [isOpenWhoAreWe, setIsOpenWhoAreWe] = useState(false);
  const [openWhoAreWe, setOpenWhoAreWe] = useState(false);
  const [openDush, setOpenDush] = useState(false);
  const [openRodyna, setOpenRodyna] = useState(false);
  const [openPoklikannya, setOpenPoklikannya] = useState(false);
  const [isOpenBosco, setIsOpenBosco] = useState(false);
  const [isOpenVocation, setIsOpenVocation] = useState(false);
  const [isOpenDushpastyr, setIsOpenDushpastyr] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const whoAreWeLinks = {
    title: 'Хто ми',
    items: [
      { label: 'Святий Іван Боско', link: '/svyatij-ivan-bosko' },
      { label: 'Салезіянська Харизма', link: '/saleziyanska-harizma' },
      { label: 'Салезіяни в Україні', link: '/saleziyani-v-ukrayini' },
      { label: 'Виконавчий уряд провінції', link: '/vikonavchij-uryad-provinciyi' },
    ],
  };

  const boscoLinks = {
    title: 'Салезіянська родина',
    items: [
      { label: 'Салезіяни отця Боско', link: '/saleziyani-otcya-bosko' },
      { label: 'Отець Боско сьогодні', link: '/otec-bosko-sogodni' },
      { label: 'Сестри Салезіянки (Дочки Марії Помічниці Християн)', link: '/dochki-mariyi-pomichnici-fma' },
      { label: 'Салезіянські співпрацівники', link: '/saleziyani-spivpracivniki' },
      { label: 'Салезіянські випускники', link: '/saleziyanski-vipuskniki' },
      { label: 'Асоціація Марії Помічниці', link: '/asociaciya-mariyi-pomichnici' },
    ],
  };

  const vocationLinks = {
    title: 'Покликання',
    items: [
      { label: 'Пізнай Своє Покликання (ПСП)', link: '/piznaj-svoye-poklikannya' },
      { label: 'Аспірантат', link: '/aspirantat-uchitelyu-de-perebuvayesh' },
      { label: 'Кандидатура', link: '/kandidatura' },
      { label: 'Новіціат', link: '/noviciat' },
      { label: 'Постновіціат - Філософія', link: '/postnoviciat' },
      { label: 'Практика', link: '/practika' },
      { label: `Богослов'я`, link: '/bogoslivja' },
      { label: 'Постійна формація', link: '/postijna-formaciya' },
    ],
  };

  const dushpastirskiMaterialy = {
    title: 'Душпастирські матеріали',
    items: [
      { label: 'Коментар до превентивного виховання', link: '/dushpastirski-materiali' },
    ],
  };
  return (
    <>


      <header className={`${className} w-full px-0 bg-top bg-no-repeat bg-cover relative `}>
        {isHomePage && (
          <div className="absolute inset-x-0 bottom-[50px] md:bottom-[100px] z-50 flex items-center justify-center">
            <h1 className="text-4xl text-center text-white md:text-7xl xl:text-8xl">
              {phrases[activeIndex]}
            </h1>
          </div>
        )}
        <div className="relative z-20">
          <div className="relative flex flex-col items-center justify-between h-full pb-4">
            <div className="bg-[#A81414] z-50 min-w-[375px] max-md:w-full max-w-[1310px] mx-[20px] flex items-center justify-between pt-6 pb-6 text-white px-[35px] rounded-b-xl">
              <div className="z-50 flex flex-col justify-between w-2/3 md:w-1/3 md:flex-row">
                <Link to="/">
                  <p className="flex items-center gap-4 text-sm md:text-lg hover:font-semibold">

                    <img
                      className="object-cover w-12 h-12 border border-transparent rounded-full"
                      src="/images/logo22.png"
                      alt=""
                    />

                    <div className="leading-5">
                      <h2 className="pb-[2px] mb-[2px] md:border-b-2 border-red">Салезіяни Святого Івана Боско, УГКЦ</h2>
                      <h2 className="hidden md:block">Salesians of Don Bosco, Ukraine</h2>
                    </div>
                  </p>
                </Link>
              </div>
              {/* <div className="flex flex-wrap items-center justify-between w-[50%] gap-0 text-sm md:gap-x-[20px] md:text-lg z-50">
                <DropdownMenu
                  isOpen={isOpenWhoAreWe}
                  onMouseEnter={() => setIsOpenWhoAreWe(true)}
                  onMouseLeave={() => setIsOpenWhoAreWe(false)}
                  links={whoAreWeLinks}
                />
                <Link to="/novini">
                  <p className="md:uppercase text-md hover:font-semibold hover:underline"><h4>Новини</h4></p>
                </Link>
                <Link to="/socialne-pidpriyemnictvo">
                  <p className="md:uppercase text-md hover:font-semibold hover:underline"><h4>Соціальне підприємництво</h4></p>
                </Link>
                <Link to="/komunikaciya">
                  <p className="md:uppercase text-md hover:font-semibold hover:underline"><h4>Комунікація</h4></p>
                </Link>
                <DropdownMenu
                  isOpen={isOpenVocation}
                  onMouseEnter={() => setIsOpenVocation(true)}
                  onMouseLeave={() => setIsOpenVocation(false)}
                  links={vocationLinks}
                />
                <Link to="/dushpastirski-materiali">
                  <p className="md:uppercase text-md hover:font-semibold hover:underline"><h4>Душпастирські матеріали</h4></p>
                </Link>
                <DropdownMenu
                  isOpen={isOpenBosco}
                  onMouseEnter={() => setIsOpenBosco(true)}
                  onMouseLeave={() => setIsOpenBosco(false)}
                  links={boscoLinks}
                />
              </div> */}
              <nav className="relative z-50 flex md:w-[55%]">
                {/* Бургер іконка - видно лише на мобілці */}
                <div className="flex justify-end md:px-4 md:py-2 md:hidden">
                  <button className="flex flex-col items-center justify-center w-[50px] h-[50px] space-y-[4px] md:hidden" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
                    {isMobileMenuOpen ?
                      <div className="w-[40px]"><img src="/images/close-burger.svg" alt="discord" width={40} height={40} className="dark:invert" /></div>
                      :
                      <>
                        <span className="w-[28px] h-0.5 bg-white "></span>
                        <span className="w-[22px] h-0.5 bg-white "></span>
                        <span className="w-[28px] h-0.5 bg-white "></span>
                        <span className="w-[22px] h-0.5 bg-white "></span>
                      </>

                    }
                  </button>
                </div>

                {/* Меню */}
                <div className="hidden md:flex flex-wrap items-center justify-between  gap-0 text-sm md:gap-x-[20px] md:text-lg">
                  <DropdownMenu
                    isOpen={isOpenWhoAreWe}
                    onMouseEnter={() => setIsOpenWhoAreWe(true)}
                    onMouseLeave={() => setIsOpenWhoAreWe(false)}
                    links={whoAreWeLinks}
                  />
                  <Link to="/novini">
                    <p className="md:uppercase text-md hover:font-semibold hover:underline"><h4>Новини</h4></p>
                  </Link>


                  <DropdownMenu
                    isOpen={isOpenVocation}
                    onMouseEnter={() => setIsOpenVocation(true)}
                    onMouseLeave={() => setIsOpenVocation(false)}
                    links={vocationLinks}
                  />
                  <DropdownMenu
                    isOpen={isOpenDushpastyr}
                    onMouseEnter={() => setIsOpenDushpastyr(true)}
                    onMouseLeave={() => setIsOpenDushpastyr(false)}
                    links={dushpastirskiMaterialy}
                  />
                  {/* <Link to="/dushpastirski-materiali">
                    <p className="md:uppercase text-md hover:font-semibold hover:underline"><h4>Душпастирські матеріали</h4></p>
                  </Link> */}
                  <DropdownMenu
                    isOpen={isOpenBosco}
                    onMouseEnter={() => setIsOpenBosco(true)}
                    onMouseLeave={() => setIsOpenBosco(false)}
                    links={boscoLinks}
                  />
                  <Link to="/komunikaciya">
                    <p className="md:uppercase text-md hover:font-semibold hover:underline"><h4>Комунікація</h4></p>
                  </Link>
                  <Link to="/socialne-pidpriyemnictvo">
                    <p className="md:uppercase text-md hover:font-semibold hover:underline"><h4>Соціальне підприємництво</h4></p>
                  </Link>
                </div>

                {/* Мобільне меню */}
                {isMobileMenuOpen && (
                  <div className="absolute z-[9999] right-0 flex flex-col min-w-full gap-1 p-4 text-black bg-white shadow-md top-14 md:hidden">
                    <div className="relative w-full max-w-xs">
                      <button
                        onClick={() => setOpenWhoAreWe(!openWhoAreWe)}
                        className="flex items-center w-full gap-2 "
                      >
                        Хто ми
                        <span className={`transition-transform ${openWhoAreWe ? "rotate-180" : ""}`}>
                          ▾
                        </span>
                      </button>
                      {openWhoAreWe && (
                        <ul className="w-full mt-2 ">
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/svyatij-ivan-bosko"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Святий Іван Боско</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/saleziyanska-harizma"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Салезіянська харизма</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/saleziyani-v-ukrayini"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Салезіяни в Україні</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/vikonavchij-uryad-provinciyi"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Виконавчий уряд провінції</Link>
                          </li>
                        </ul>
                      )}
                    </div>
                    <Link className="" to="/novini"
                      onClick={() => {
                        setOpenWhoAreWe(false);
                        setOpenDush(false);
                        setOpenPoklikannya(false);
                        setOpenRodyna(false);
                        setOpenRodyna(false);
                        setIsMobileMenuOpen(false)
                      }}
                    >Новини</Link>
                    <div className="relative w-full max-w-xs">
                      <button
                        onClick={() => setOpenPoklikannya(!openPoklikannya)}
                        className="flex items-center w-full gap-2 "
                      >
                        Покликання
                        <span className={`transition-transform ${openPoklikannya ? "rotate-180" : ""}`}>
                          ▾
                        </span>
                      </button>
                      {openPoklikannya && (
                        <ul className="w-full mt-2 ">
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/piznaj-svoye-poklikannya"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Пізнай Своє Покликання (ПСП)</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/aspirantat-uchitelyu-de-perebuvayesh"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Аспірантат</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/kandidatura"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Кандидатура</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/noviciat"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Новіціат</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/postnoviciat"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Постновіціат- Філософія</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/practika"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Практика</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/bogoslivja"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Богослов'я</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/postijna-formaciya"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Постійна формація</Link>
                          </li>
                        </ul>
                      )}
                    </div>
                    <div className="relative w-full max-w-xs">
                      <button
                        onClick={() => setOpenDush(!openDush)}
                        className="flex items-start w-full gap-2 text-start whitespace-nowrap "
                      >
                        Душпастирські матеріали
                        <span className={`transition-transform ${openDush ? "rotate-180" : ""}`}>
                          ▾
                        </span>
                      </button>
                      {openDush && (
                        <ul className="w-full mt-2 ">
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/dushpastirski-materiali"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >
                              Коментар до превентивного виховання</Link>
                          </li>

                        </ul>
                      )}
                    </div>
                    <div className="relative w-full max-w-xs">
                      <button
                        onClick={() => setOpenRodyna(!openRodyna)}
                        className="flex items-center w-full gap-2 "
                      >
                        Салезіянська родина
                        <span className={`transition-transform ${openRodyna ? "rotate-180" : ""}`}>
                          ▾
                        </span>
                      </button>
                      {openRodyna && (
                        <ul className="w-full mt-2 ">
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/saleziyani-otcya-bosko"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Салезіяни отця Боско</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/otec-bosko-sogodni"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Отець Боско сьогодні</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/dochki-mariyi-pomichnici-fma"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Сестри Салезіянки (Дочки Марії Помічниці Християн)</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/saleziyani-spivpracivniki"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Салезіянські співпрацівники</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/saleziyanski-vipuskniki"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Салезіянські випускники</Link>
                          </li>
                          <li className="ml-6 text-sm underline cursor-pointer hover:bg-gray-100">
                            <Link to="/asociaciya-mariyi-pomichnici"
                              onClick={() => {
                                setOpenWhoAreWe(false);
                                setOpenDush(false);
                                setOpenPoklikannya(false);
                                setOpenRodyna(false);
                                setOpenRodyna(false);
                                setIsMobileMenuOpen(false)
                              }}
                            >Асоціація Марії Помічниці</Link>
                          </li>
                        </ul>
                      )}
                    </div>
                    <Link className="" to="/komunikaciya"
                      onClick={() => {
                        setOpenWhoAreWe(false);
                        setOpenDush(false);
                        setOpenPoklikannya(false);
                        setOpenRodyna(false);
                        setOpenRodyna(false);
                        setIsMobileMenuOpen(false)
                      }}
                    >Комунікація</Link>
                    <Link to="/socialne-pidpriyemnictvo"
                      onClick={() => {
                        setOpenWhoAreWe(false);
                        setOpenDush(false);
                        setOpenPoklikannya(false);
                        setOpenRodyna(false);
                        setOpenRodyna(false);
                        setIsMobileMenuOpen(false)
                      }}
                      className="whitespace-nowrap ">Соціальне підприємництво</Link>

                  </div>
                )}
              </nav>
            </div>

          </div>
        </div>
      </header>
    </>

  );
}

export default Header;
